import {
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  inject,
  input,
  OnInit,
  signal,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { map } from 'rxjs';
import { MediaObserverService } from '../media-observer.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MediaBreakpoints } from '../consts/media-breakpoints.interface';

@Directive({
  selector: '[libMediaShowUp]',
})
export class MediaShowUpDirective implements OnInit {
  breakpoint = input.required<keyof MediaBreakpoints>({ alias: 'libMediaShowUp' });

  includeEquals = input<boolean>(true, {
    alias: 'libMediaShowUpIncludeEquals',
  });

  protected hasView = signal<boolean>(false);

  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly mediaObserver = inject(MediaObserverService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly destroy = inject(DestroyRef);

  public ngOnInit(): void {
    this.mediaObserver.breakpoint$
      .pipe(
        map(breakpoint => this.mediaObserver.isBreakpointUp(breakpoint, this.breakpoint(), this.includeEquals())),
        takeUntilDestroyed(this.destroy)
      )
      .subscribe(shouldShow => {
        if (shouldShow && !this.hasView()) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView.set(true);
          this.cd.markForCheck();
        } else if (!shouldShow && this.hasView) {
          this.viewContainer.clear();
          this.hasView.set(false);
          this.cd.markForCheck();
        }
      });
  }
}
